<template>
    <div v-if="client" class="container bng-casino-home bng-narrow-container">
        <!-- banner and last winnings -->
        <div class="columns is-multiline is-gapless">
            <div v-if="client.view.banners.casinoHomeBanner" class="column is-full is-two-thirds-fullhd">
                <casino-home-banner />
            </div>
            <div v-if="client.view.banners.casinoHomeCustomBanner" class="column is-full is-two-thirds-fullhd">
                <casino-home-custom-banner />
            </div>
            <div class="column is-full is-4-fullhd bng-winnings-block">
                <last-winnings />
            </div>
        </div>

        <!-- jackpots -->
        <h3
            v-if="jackpots && jackpots.length"
            class="title title-jackpots is-3 is-spaced has-text-centered has-text-weight-normal"
        >
            <span class="icon has-text-warning">
                <i class="fas fa-crown"></i>
            </span>
            <span class="has-text-warning">{{"components.pages.casino-home.jackpot" | translate}}</span>
            <span class="icon has-text-warning">
                <i class="fas fa-crown"></i>
            </span>
        </h3>
        <jackpots-bar v-if="jackpots && jackpots.length"/>

        <!-- popular games -->
        <h3
            v-if="popularGames && popularGames.length"
            class="title title-popular is-3 is-spaced has-text-centered has-text-weight-normal"
        >
            <span class="icon mbk-category-icon has-text-warning">
                <i class="fas fa-star"></i>
            </span>
            {{"components.pages.casino-home.popular" | translate}}
            <span
                class="icon mbk-category-icon has-text-warning"
            >
                <i class="fas fa-star"></i>
            </span>
        </h3>
        <game-list v-if="popularGames && popularGames.length" :games="popularGames" />

        <!-- new games -->
        <h3
            v-if="newGames && newGames.length"
            class="title title-new is-3 is-spaced has-text-centered has-text-weight-normal"
        >
            <span class="icon mbk-category-icon has-text-danger">
                <i class="fas fa-fire"></i>
            </span>
            {{"components.pages.casino-home.new" | translate}}
            <span
                class="icon mbk-category-icon has-text-danger"
            >
                <i class="fas fa-fire"></i>
            </span>
        </h3>
        <game-list v-if="newGames && newGames.length" :games="newGames" />
    </div>
</template>
<script>
import Vue from 'vue';

import CasinoHomeBanner from '../../../common/banners/casino-banners/casino-home-banner.vue';
import CasinoHomeCustomBanner from '../../../common/banners/casino-banners/casino-home-custom-banner.vue';
import LastWinnings from '../../../common/last-winnings/last-winnings.vue';
import JackpotsBar from '../../../common/jackpots/jackpots-bar/jackpots-bar.vue';
import GameList from '../../../common/game-list/game-list.vue';

export default {
    name: 'casino-home',
    components: { CasinoHomeBanner, CasinoHomeCustomBanner, LastWinnings, JackpotsBar, GameList },
    computed: {
        client() {
            return Vue.state.client.get();
        },
        popularGames() {
            return Vue.state.games.get().popular;
        },
        newGames() {
            return Vue.state.games.get().new;
        },
        player() {
            return Vue.state.player.get();
        },
        jackpots() {
            return (
                (this.player &&
                    this.player.balance &&
                    this.player.activeJackpots) ||
                []
            );
        }
    },
    async created() {
        await Vue.state.client.ensure();
    }
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/casino-home/casino-home.vue